import React, { useState } from "react";
import { Upload } from "lucide-react";

const Marketing = () => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileUpload = (e) => setSelectedFile(e.target.files[0]);

    const uploadExcel = () => {
        if (!selectedFile) {
            alert("Please select an Excel file first");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        fetch("/api/customers/upload-excel", { method: "POST", body: formData })
            .then((res) => res.json())
            .then(() => alert("Excel uploaded successfully"))
            .catch(() => alert("Upload failed"));
    };

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    backgroundColor: '#fff',
                    zIndex: 1000,
                    boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
                    padding: '0px 0px',
                    height: '60px',
                }}
            >
                <div className="w-full" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="title" onClick={() => (window.location.href = '#')} style={{ alignItems: 'left', marginLeft: '20px', paddingTop: '10px', cursor: 'pointer', display: 'flex' }} >
                        <img src="https://zordigo.com/assets/Logo2.png" className="w-10 h-auto" alt="Zordigo Logo" />
                        <b style={{ color: "#c1272c" }}>Zordigo</b>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "24px", marginRight: "20px", }} >
                        <button
                            onClick={() => {
                                const link = document.createElement("a");
                                link.href = "/assets/customer-sample.xlsx";
                                link.download = "customer-sample.xlsx";
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            }}
                            title="Download Sample Excel" style={{ cursor: "pointer" }}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-file-earmark-arrow-down" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.6" d="M8.5 6.5a.5.5 0 0 0-1 0v3.793L6.354 9.146a.5.5 0 1 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                                <path stroke="currentColor" strokeWidth="0.6" d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                            </svg>
                        </button>

                        <div title="View Uploaded Data" onClick={() => (window.location.href = "/customer-data-list")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-table" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.6" d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm15 2h-4v3h4zm0 4h-4v3h4zm0 4h-4v3h3a1 1 0 0 0 1-1zm-5 3v-3H6v3zm-5 0v-3H1v2a1 1 0 0 0 1 1zm-4-4h4V8H1zm0-4h4V4H1zm5-3v3h4V4zm4 4H6v3h4z" />
                            </svg>
                        </div>

                        <div title="Log Out" onClick={() => (window.location.href = "/")} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16" color="#c1272c" >
                                <path stroke="currentColor" strokeWidth="0.6" fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0V3.5A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                <path stroke="currentColor" strokeWidth="0.6" fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>

            {/* Panel Wrapper */}
            <div className="w-80% max-w-4xl bg-white rounded-2xl shadow-2xl border border-gray-200 p-8 md:p-12" style={{ marginTop: '30px' }}>

                {/* Page Header */}
                <header className="text-center mb-12">
                    <h1 className="text-4xl font-bold text-gray-800 tracking-tight">
                        Customer Data Management
                    </h1>
                    <p className="text-gray-500 text-lg mt-2">
                        Manage, upload and track customer records securely.
                    </p>
                </header>

                {/* Main Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-1 gap-10">

                    {/* Upload Section */}
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 shadow-md rounded-xl p-6 hover:shadow-lg transition">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2 justify-center">
                            <Upload className="w-6 h-6 text-blue-600" />
                            Upload Excel File
                        </h2>

                        <div className="space-y-4">
                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={handleFileUpload}
                                className="w-full border rounded-lg px-4 py-3 bg-white shadow-sm focus:ring-2 focus:ring-blue-500 transition"
                            />

                            <button
                                onClick={uploadExcel}
                                className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition shadow-md flex items-center justify-center gap-2"
                            >
                                <Upload className="w-5 h-5" />
                                Upload Excel
                            </button>
                        </div>
                    </div>

                    {/* Actions Section */}
                    <div className="flex flex-col justify-between gap-6">
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Marketing;